import { Modal } from 'antd'
import resso from 'resso'
import * as Api from '@/api/account'
import { getSystemConfig, getUserInfo } from './api/account'

export interface IUserPackage {
  membership_credits: number
  current_membership_credits: number
  current_membership_package_title: string
  membership_expire_time: number
  membership_expired: boolean
  permanent_credits: number
  free_credits: number
  current_membership_level: number
}

export interface IProduct {
  title: string
  duration_type: number
  id: number
  unit_credits: number
  units: number
  total_price: number
  discounted_unit_price: number
  original_unit_price: number
  level: number
  status: number
}

export interface ISystemConfig {
  background_image: string
  display_name: string
  head_logo: string
  logo: string
  name: string
  welcome_line: string
  ico_url: string
  privacy_agreement_url: string
  service_agreement_url: string
  eula_url: string
  keywords: string
  description: string
  promote_image: string
  digital_human_cost: number
  icp_filing_no: string
  credit_text: string
}

export const UserStore = resso({
  phone: '',
  uid: '',
  config: {} as ISystemConfig,
  getSystemConfig: async () => {
    if (!UserStore.config.name) {
      const res = await getSystemConfig({ domain: location.hostname })
      UserStore.config = res
      document.title = res.display_name
      const icon = document.querySelector('#link-icon') as any
      if (icon) {
        icon.href = res.ico_url
      }
    }
  },
  setUserToken: (d: any) => {
    localStorage.setItem('token', d.token)
    getUserInfo()
  },
  setUserInfo: (d: any) => {
    UserStore.phone = d.phone
    UserStore.uid = d.uid
    UserStore.checkWatermarkTip()
  },
  getToken: () => {
    return localStorage.getItem('token')
  },
  loginOut: () => {
    localStorage.removeItem('token')
    location.replace('/login')
  },
  checkWatermarkTip: async () => {
    const uid = UserStore.uid
    const watermarkTip = localStorage.getItem(`watermarkTip-${uid}`)
    if (!watermarkTip && uid) {
      const res = await Api.getAiWatermarkState()
      if (res?.should_show && !res?.notified) {
        Modal.warning({
          width: 600,
          title: '功能升级通知',
          content: `根据《人工智能生成合成内容标识办法》，自2025年9月1日起，您创作的作品会默认打上显式和隐式水印。根据您的实际业务情况，可在"个人中心“进行AI显式标识开关的配置。`,
          okText: '我已知晓',
          onOk: () => {
            Api.updateAiWatermarkState({ notified: true })
            localStorage.setItem(`watermarkTip-${uid}`, '1')
          }
        })
      }
    }
  }
})
